import { Box } from "@material-ui/core";
import { Icon, IconName } from "halifax";
import React from "react";
import "./styles.scss";

export const WishlistHeaderItem = () => {
  return (
    <Box
      className="wishlist-header-item"
      display="flex"
      justifyContent="center"
      alignItems="center"
      paddingLeft="33px"
      marginLeft="33px"
      style={{
        borderLeft: "0.5px solid var(--grey-11)",
      }}
    >
      <Icon
        width="17px"
        height="17px"
        name={IconName.WishlistHeart}
        fill="red"
      />
    </Box>
  );
};
